import * as actionTypes from "../actions/actionTypes";
import {updateObject} from "../../Utils/utils";

const initialState = {
    comments: [],
    commentLoading: false,
    commentSubmitLoading: false,
    error: null,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.POST_COMMENT_INIT:
            return updateObject(state, {comments: [], error: null})
        case actionTypes.POST_COMMENT_START:
            return updateObject(state, {commentLoading: true})
        case actionTypes.POST_COMMENT_SUCCESS:
            return updateObject(state, {comments: action.comments, commentLoading: false, error: null})
        case actionTypes.POST_COMMENT_FAIL:
            return updateObject(state, {commentLoading: false, error: action.error})
        case actionTypes.POST_COMMENT_TOGGLE_UPVOTE_SUCCESS:
            const commentsListClone = [...state.comments]
            const commentClone = {...commentsListClone[action.id - 1]}
            const point = action.flag ? -1 : 1
            commentClone.points = +commentClone.points + point
            commentsListClone[action.id - 1] = commentClone
            return updateObject(state, {comments: commentsListClone})
        case actionTypes.POST_COMMENT_SUBMIT_START:
            return updateObject(state, {commentSubmitLoading: true})
        case actionTypes.POST_COMMENT_SUBMIT_SUCCESS:
            return updateObject(state, {
                comments: [...state.comments, {
                    ...action.comment,
                    id: state.comments.length + 1,
                    commentId: action.commentId
                }],
                commentSubmitLoading: false,
                error: null
            })
        case actionTypes.POST_COMMENT_SUBMIT_FAIL:
            return updateObject(state, {commentSubmitLoading: false, error: action.error})
        default:
            return state
    }
}

export default reducer;